import { NgModule } from '@angular/core';

import {PricePipe} from './pipes/price/price.pipe';
import {ToPlainTextPipe} from './pipes/toPlainText/toPlainText.pipe';
import {MomentPipe} from './pipes/moment/moment.pipe';
import {PeriodPipe} from './pipes/period/period.pipe';
import {TrimPipe} from './pipes/trim/trim.pipe';
import {TicketPricePipe} from './pipes/ticketPrice/ticketPrice.pipe';
import {RolesPipe} from './pipes/roles/roles.pipe';
import {PriceInWordsPipe} from './pipes/priceInWords/priceInWords.pipe';
import {PriceInCentsPipe} from './pipes/priceInCents/priceInCents.pipe';
import {TrimCustomerNamePipe} from './pipes/trimCustomerName/trimCustomerName.pipe';
import {ArrayToStringPipe} from './pipes/arrayToString/arrayToString.pipe';
import {AddSpacesPipe} from './pipes/addSpaces/addSpaces.pipe';
import {PhoneNumberPipe} from "./pipes/phoneNumber/phoneNumber.pipe";
import {QuantityInPcsPipe} from './pipes/quantityInPcs/quantityInPcs.pipe';
import {NormalizeStringPipe} from './pipes/normalizeString/normalizeString.pipe';
import {MapStringToLocationPipe} from './pipes/mapStringToLocation/mapStringToLocation.pipe';
import {TranslateValuePipe} from './pipes/translateValue/translateValue.pipe';
import {PaymentTypePipe} from "./pipes/payment/paymentType.pipe";
import {PaymentMethodPipe} from "./pipes/payment/paymentMethod.pipe";

const pipes = [
  PricePipe,
  ToPlainTextPipe,
  MomentPipe,
  PeriodPipe,
  TrimPipe,
  TicketPricePipe,
  RolesPipe,
  PriceInWordsPipe,
  PriceInCentsPipe,
  TrimCustomerNamePipe,
  ArrayToStringPipe,
  AddSpacesPipe,
  PhoneNumberPipe,
  QuantityInPcsPipe,
  NormalizeStringPipe,
  MapStringToLocationPipe,
  TranslateValuePipe,
  PaymentTypePipe,
  PaymentMethodPipe
];

@NgModule({
  declarations: pipes,
  exports: pipes,
  providers: pipes
})

export class PipesModule {}
